<template>
  <div class="container lnb d_container">
    <div class="contents_wrap">
      <div class="contents list-container">
        <div class="title">{{ $route.meta.title }}</div>
        <div class="list-content content tab-content">
          <div
              class="intro_tab col_6"
              @click="movePage('ssamsUpdate')"
              :class="{ active: tab === 'ssamsUpdate' }"
          >
            Ssams
          </div>
          <div
              class="intro_tab col_6"
              @click="movePage('ssamsContent')"
              :class="{ active: tab === 'ssamsContent' }"
          >
            콘텐츠
          </div>
          <div
              class="intro_tab col_6"
              @click="movePage('ssamsKoreanTalk')"
              :class="{ active: tab === 'ssamsKoreanTalk' }"
          >
            Q&A
          </div>
        </div>
        <div v-if="tab === 'ssamsUpdate'" class="list-content">
          <ssams-write-component
              :ssamsType="'ssamsUpdate'"
              :ssamsKey="ssamsKey"
          ></ssams-write-component>
          <div class="pa15 text-center btn_wrap">
            <el-button type="save" @click="save">저장</el-button>
            <el-button type="cancel" @click="backEvent()" :disabled="disableBtn"
            >목록</el-button
            >
            <el-button type="delete" @click="deleteFunc()">삭제</el-button>
          </div>
        </div>
        <board-list-component
            class="list-content"
            :boardType="`ssamsContent`"
            v-else-if="tab === 'ssamsContent'"
            :userKey="userKey"
            :ssamsKey="ssamsKey"
        ></board-list-component>
        <board-list-component
            class="list-content"
            :boardType="`ssamsKoreanTalk`"
            v-else-if="tab === 'ssamsKoreanTalk'"
            :userKey="userKey"
            :ssamsKey="ssamsKey"
        ></board-list-component>
      </div>
      <div class="footer-copyright">Copyright 2021. Peopleandtalk co.,Ltd. All rights reserved</div>
    </div>
  </div>
</template>

<script>
import EventBus from "@/utils/event-bus";
import SsamsWriteComponent from "@/components/ssams/SsamsWriteComponent";
import BoardListComponent from "@/components/board/BoardListComponent";

let fromList = false;
export default {
  name: "SsamsContent",
  mixins: [],
  components: { SsamsWriteComponent, BoardListComponent },
  provide() {
    return {};
  },
  props: {},
  data() {
    return {
      ssamsKey: Number(this.$route.params.s_idx),
      disableBtn: false,
      tab: "ssamsContent",
      userKey: "",
    };
  },
  beforeRouteEnter(to, from, next) {
    if(from.path === '/content/ssams') {
      fromList = true;
    }
    next();
  },
  created() {
    EventBus.$on("ssamsData", (res) => {
      this.userKey = res.mb_no;
    });
  },
  mounted() {},
  beforeDestroy() {
    EventBus.$off("ssamsData");
  },
  destroyed() {},
  computed: {},
  methods: {
    save() {
      EventBus.$emit("writeSsams");
    },
    backEvent() {
      this.disableBtn = true;
      this.$router.back();
    },
    deleteFunc() {
      EventBus.$emit("deleteSsams");
    },

    movePage(url) {
      this.$router.replace(`/content/ssams/${this.ssamsKey}/${url}`)
    },
  },
  watch: {
  },
};
</script>

<style lang="scss"></style>
